module.exports = {
	"pathContext": {
		"name": "tahoe",
		"photos": [
			"tahoe/DSC_1487.jpg",
			"tahoe/DSC_1490.jpg",
			"tahoe/DSC_1493.jpg",
			"tahoe/DSC_1496.jpg",
			"tahoe/DSC_1551-Pano.jpg",
			"tahoe/DSC_1553.jpg",
			"tahoe/DSC_1577.jpg",
			"tahoe/DSC_1582.jpg",
			"tahoe/DSC_1583.jpg",
			"tahoe/DSC_1584.jpg",
			"tahoe/DSC_1585.jpg",
			"tahoe/DSC_1602.jpg",
			"tahoe/DSC_1608.jpg"
		],
		"next": {
			"name": "lapland"
		},
		"previous": {
			"name": "berlin"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/photos-tahoe.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/photos-tahoe.json
// module chunks = 5526006329927355000